/**
 * Styleguide Routes
 */
import React from 'react';
import { Route, Navigate } from 'react-router-dom';

// Lazy load styleguide components
const Styleguide = React.lazy(() => import('../styleguide/Styleguide'));
const Color = React.lazy(() => import('../styleguide/color/Color'));
const Typography = React.lazy(() => import('../styleguide/typography/Typography'));
const Button = React.lazy(() => import('../styleguide/button/Button'));
const FormGroup = React.lazy(() => import('../styleguide/FormGroup/FormGroup'));

export const StyleguideRoutes = (
  <Route path="/styleguide" element={<Styleguide />}>
    <Route path="Color" element={<Color />} />
    <Route path="Typography" element={<Typography />} />
    <Route path="Button" element={<Button />} />
    <Route path="Form" element={<FormGroup />} />
    <Route index element={<Navigate to="Color" replace />} />
  </Route>
);
